import { newApi } from "./api.js";
import { trackEvent } from "./analytics/track_event.js";
export var newAppContext = function newAppContext(config) {
  return {
    now: function now() {
      return new Date();
    },
    api: newApi({
      fetch: window.fetch.bind(window),
      config: config
    }),
    window: window,
    document: window.document,
    env: process.env,
    trackEvent: trackEvent
  };
};